export enum COLORS {
  GREEN = '#90ee90',
  GREEN2 = '#57BA9B',
  RED = '#ffb6c1',
  ORANGE = '#ff8000',
  YELLOW = '#f7fa96',
  WHITE = '#FFFFFF',
  BLUE = '#b4d3f3',
  GRAY = '#778899',
  GRAY2 = '#6c757d',
  GRAY2LIGHT = '#ced4da',
  GRAY2LIGHT2 = '#dee2e6',
  GRAY3 = '#F3F3F3',
  DARKGREEN = '#428942',
  BLACK = '#000000',
  MINT1 = '#E0EFEE',
  SAND = '#fff8e2',
  REDBRIGHT = '#FF0000',
  DARKGREEN2 = '#008000',
  MINT2 = '#23A49A',
  MINT3 = '#1AB78A',
  BACKGROUND = '#FCFCFC'
}
